import React, {useState, useContext, useEffect, useRef} from 'react'
import {Modal, Input, Row, Col, notification, Table, Select, Button, Form } from 'antd';
import { FaCheck, FaTimes, FaInfoCircle } from "react-icons/fa";
import { getAllProducts } from '../services/ProductsService';

const { Option } = Select;
const EditableContext = React.createContext(null);

const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
      <Form form={form} component={false}>
        <EditableContext.Provider value={form}>
          <tr {...props} />
        </EditableContext.Provider>
      </Form>
    );
  };
  
  const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    ...restProps
  }) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const form = useContext(EditableContext);
    useEffect(() => {
      if (editing) {
        inputRef.current.focus();
      }
    }, [editing]);
  
    const toggleEdit = () => {
      setEditing(!editing);
      form.setFieldsValue({
        [dataIndex]: record[dataIndex],
      });
    };
  
    const save = async () => {
      try {
        const values = await form.validateFields();
        toggleEdit();
        handleSave({ ...record, ...values });
      } catch (errInfo) {
      }
    };
  
    let childNode = children;
  
    if (editable) {
      childNode = editing ? (
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
          rules={[
            {
              required: true,
              message: `${title} es requerido.`,
            },
          ]}
        >
          <Input ref={inputRef} onPressEnter={save} onBlur={save} />
        </Form.Item>
      ) : (
        <div
          className="editable-cell-value-wrap"
          style={{
            paddingRight: 24,
          }}
          onClick={toggleEdit}
        >
          {children}
        </div>
      );
    }
  
    return <td {...restProps}>{childNode}</td>;
  };

function SetModalNew(props){
    const[nombre, setNombre] = useState("");
    const[dataProducts, setDataProducts] = useState([]);
    const[tempProducts, setTempProducts] = useState([]);
    const[tableProductsLoading, setTableProductsLoading] = useState(false);
    const[categoryId, setCategoryId] = useState("S");
    const[category, setCategory] = useState("");
    const[btnAddDisabled, setbtnAddDisabled] = useState(true);
    const[btnDeleteDisabled, setbtnDeleteDisabled] = useState(true);
    const[selectedProducts, setSelectedProducts] = useState([]);
    const[selectedRowKeysProducts, setSelectedRowKeysProducts] = useState([]);
    const[selectedRowKeysPaquete, setSelectedRowKeysPaquete] = useState([]);
    const[selectedDataPaquete, setSelectedDataPaquete] = useState([]);
    const[dataPaquete, setDataPaquete] = useState([]);
    const [searchValue, setSearchValue] = useState('');

    const msNotification = (type, title, desc) => {
        notification[type]({
            message: title,
            description:
            desc,
        });
    };

    const handleOk = () => {
        if(nombre !== ""){
            if(dataPaquete.length > 0){
                const Products = [];
                let flgCantidad = true;
                dataPaquete.map(function(obj){
                    if(obj.quantity === 0)
                        flgCantidad = false;
                    const product = {
                        categoryId:obj.categoryId,
                        id:obj.id,
                        quantity:obj.quantity
                    };
                    Products.push(product);
                    return true;
                });
                if(flgCantidad){
                    props.handleOkModalNew(nombre, Products);
                    setNombre("");
                    setDataProducts([]);
                    setTempProducts([]);
                    setDataPaquete([]);
                    setSelectedProducts([]);
                    setSelectedRowKeysProducts([]);
                    setSelectedRowKeysPaquete([]);
                    setSelectedDataPaquete([]);
                    setCategoryId("S");
                    setSearchValue("");
                }else{
                    msNotification('warning', 'Paquete', 'Algunos productos tienen cantidad 0 en el paquete.');
                }
                
            }else{
                msNotification('warning', 'Paquete', 'Agrega productos en el paquete.');
            }
        }else{
            msNotification('warning', 'Paquete', 'El nombre del Paquete no debe de ser vacio.');
        }
      };

    const handleCancel = () => {
        setNombre("");
        setDataProducts([]);
        setTempProducts([]);
        setDataPaquete([]);
        setSelectedProducts([]);
        setSelectedRowKeysProducts([]);
        setSelectedRowKeysPaquete([]);
        setSelectedDataPaquete([]);
        setCategoryId("S");
        setSearchValue("");
        props.handleCancelModalNew();
    }

    const handleNameChange = (e) => {
        setNombre(e.target.value);
    }

    const handleClickAdd = () =>{
        const temp = [...dataPaquete];
        selectedProducts.map(function(obj){
            let flgProd = true;
            dataPaquete.map(function(objp){
                if(obj.id === objp.id && categoryId === objp.categoryId)
                    flgProd = false;
                return true;
            });
            if(flgProd){
                const item = {
                    id:obj.id,
                    product:obj.name,
                    categoryId:categoryId,
                    category:category,
                    quantity:0
                };
                temp.push(item);
            }
            return true;
        });
        setDataPaquete(temp);
        setSelectedRowKeysProducts([]);
        setbtnAddDisabled(true);
    }

    const handleClickDelete = () =>{
        const temp = [];
        dataPaquete.map(function(obj, index){
            let flgProd = true;
            selectedDataPaquete.map(function(objs){
                if(obj.id === objs.id && obj.categoryId === objs.categoryId )
                    flgProd = false;
                return true;
            });
            if(flgProd){
                temp.push(obj);
            }
            return true;
        });
        setDataPaquete(temp);
        setSelectedRowKeysPaquete([]);
        setbtnDeleteDisabled(true);
    }

    const onSelectChange = (selectedRowKeys, selectedRow) => {
        setSelectedProducts(selectedRow);
        setSelectedRowKeysProducts(selectedRowKeys);
        if(selectedRowKeys.length > 0){
            setbtnAddDisabled(false);
        }else{
            setbtnAddDisabled(true);
        }
            
    };

    const onSelectChangePaquete = (selectedRowKeys, selectedRow) => {
        setSelectedDataPaquete(selectedRow);
        setSelectedRowKeysPaquete(selectedRowKeys);
        if(selectedRowKeys.length > 0){
            setbtnDeleteDisabled(false);
        }else{
            setbtnDeleteDisabled(true);
        }
    };

    const rowSelection = {
        selectedRowKeys: selectedRowKeysProducts,
        onChange: onSelectChange,
    };

    const rowSelectionPaquete = {
        selectedRowKeys: selectedRowKeysPaquete,
        onChange: onSelectChangePaquete,
    };

    function handleChangeCategory(value, event) {
        if(value !== "S"){
            setCategory(event.children);
            setTableProductsLoading(true);
            setCategoryId(value);
            async function allProducts(){
                const { data } = await getAllProducts(value);
                setDataProducts(data);
                setTempProducts(data);
                setTableProductsLoading(false);
              }
              allProducts();
            
        }else{
            setCategory("");
            setDataProducts([]);
            setTempProducts([]);
        }
        
    }

    const handleSave = (row) => {
        if(parseFloat(row.quantity) >= 0){
            row.quantity = parseFloat(row.quantity);
            const newData = [...dataPaquete];
            const index = newData.findIndex((item) => row.id === item.id);
            const item = newData[index];
            newData.splice(index, 1, { ...item, ...row });
            setDataPaquete(newData);
        }
        
    };

    const handleSearchProduct = (e) =>{
        const currValue = e.target.value;
        setSearchValue(currValue);
        const filteredData = dataProducts.filter(entry =>
        entry.name.toUpperCase().includes(currValue.toUpperCase())
        );
        if(currValue !== ""){
            setDataProducts(filteredData);
        }else{
            setDataProducts(tempProducts);
        }
        
    };

    const columnsProducts = [
        {
          title: "Información",
          render: (record) => (
            <React.Fragment>
              {record.id}
              <br />
              {record.name}
              <br />
            </React.Fragment>
          ),
          responsive: ["xs"]
        },
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            responsive: ["sm"]
        },
        {
            title: 'Producto',
            dataIndex: 'name',
            responsive: ["sm"]
        },
    ];

    const columnsPaquete = [
        {
            title: "Información",
            render: (record) => (
            <React.Fragment>
                {record.product}
                <br />
                {record.category}
                <br />
            </React.Fragment>
            ),
            responsive: ["xs"]
        },
        {
            title: 'ID Categoria',
            dataIndex: 'categoryId',
            responsive: ["sm"]
        },
        {
            title: 'Categoria',
            dataIndex: 'category',
            responsive: ["sm"]
        },
        {
            title: 'ID Producto',
            dataIndex: 'id',
            key: 'id',
            responsive: ["sm"]
        },
        {
            title: 'Producto',
            dataIndex: 'product',
            responsive: ["sm"]
        },
        {
            title: 'Cantidad',
            dataIndex: 'quantity',
            editable: true,
        },
    ];

    const components = {
        body: {
            row: EditableRow,
            cell: EditableCell,
        },
    };

    const columnss = columnsPaquete.map((col) => {
        if (!col.editable) {
            return col;
        }
    
        return {
            ...col,
            onCell: (record) => ({
            record,
            editable: col.editable,
            dataIndex: col.dataIndex,
            title: col.title,
            handleSave: handleSave,
            }),
        };
    });

    return(
        <React.Fragment>
            <Modal title="Nuevo Paquete" 
            visible={props.modalVisibleNew} 
            width={1000}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={[
                <Button key="back" onClick={handleCancel}>
                  Cancelar
                </Button>,
                <Button key="submit" type="primary" onClick={handleOk}>
                  Guardar
                </Button>
              ]}>
                <Row>
                    <Col span={24}>
                        <Input value={nombre} onChange={handleNameChange} placeholder="Nombre" />
                    </Col>
                    <Col span={24}>
                        <br/>
                    </Col>
                </Row>
                <Row>
                    <Col span={18}>
                        <Select value={categoryId} className="cbx-widht" onChange={handleChangeCategory}>
                            <Option value="S">Selecciona una Categoría</Option>
                            {props.dataCategories.map(function(obj){
                                return <Option key={obj.id} value={obj.id}>{obj.name}</Option>
                            })}
                        </Select>
                    </Col>
                    <Col span={6}>
                        <div className="divRight">
                            <Button type="primary" icon={<FaCheck/>} onClick={handleClickAdd} disabled={btnAddDisabled}>
                            &nbsp; Agregar
                            </Button>
                        </div>
                    </Col>
                    <Col span={6} offset={18}>
                        <br/>
                        <Input
                            placeholder="Buscar producto"
                            value={searchValue}
                            onChange={handleSearchProduct}/>
                    </Col>
                    <Col span={24}>
                        <br/>
                        <Table rowKey="id" rowSelection={rowSelection} dataSource={dataProducts} columns={columnsProducts} loading={tableProductsLoading}/>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <br/>
                    </Col>
                    <Col span={24}>
                        <label>Paquete:</label>
                        <div className="divRight">
                            <Button type="primary" icon={<FaTimes/>} onClick={handleClickDelete} disabled={btnDeleteDisabled}>
                            &nbsp; Quitar
                            </Button>
                        </div>
                    </Col>
                    <Col span={24}>
                        
                        <hr/>
                        <br/>
                        <Table rowKey="id" components={components} rowSelection={rowSelectionPaquete} dataSource={dataPaquete} columns={columnss}/>
                        <label><FaInfoCircle/> Para modificar la cantidad debes dar clic en la celda que contiene el valor.</label>
                        <hr/>
                    </Col>
                </Row>
            </Modal>

        </React.Fragment>
    )
}

export default SetModalNew;



// WEBPACK FOOTER //
// ./src/components/SetModalNew.jsx